// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import VueAnalytics from 'vue-analytics'
import i18n from './lang'
import CripNotice from 'crip-vue-notice'
import Vuetify from 'vuetify'
import FBSignInButton from 'vue-facebook-signin-button'
// import('../node_modules/vuetify/dist/vuetify.min.css')
import 'vuetify/dist/vuetify.min.css'

const HelloJs = require('hellojs/dist/hello.all.js')
const VueHello = require('vue-hellojs')

Vue.use(CripNotice)
Vue.use(Vuetify)
Vue.use(VueAnalytics, {
  id: ['UA-43311385-1', 'UA-43311385-5'],
  checkDuplicatedScript: true,
  router
})
Vue.use(FBSignInButton)
Vue.config.productionTip = false
Vue.prototype.$apiUrl = `/api`
Vue.prototype.$requiredFields = ['birthDate', 'email', 'firstName', 'lastName', 'phone']

/* Router language middleware */
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('/ru') === 0) {
    i18n.locale = 'ru'
    store.commit('var', { type: 'config', i: 'language', v: 'ru' })
  }
  next()
})

HelloJs.init({
  google: '1049051934416-tq7q7itbn62gftu7gmmp1tjnho0vpvmq.apps.googleusercontent.com',
  facebook: '1587333081396128'
}, {
  redirect_uri: '/'
})
Vue.use(VueHello, HelloJs)

let timeout = 0
const refresh = () => {
  clearTimeout(timeout)
  timeout = setTimeout(() => {
    window.location.reload(true)
  }, 10 * 60 * 1000)
}
refresh()
document.addEventListener('click', refresh)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js